import SaveIcon from '@mui/icons-material/Save';
import { CircularProgress, Grid, IconButton, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../components/atoms/custom-select';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import {
  homeButtonComponent,
  pointerCursor,
  SavedViewStyle,
  SaveIconStyle,
  modernFilterPanel,
} from '../../styles';
import Filter from './Filter';

//Left Panel to show on List/Detailed list page
const LeftPanel = props => {
  const {
    handleSearchChange = () => {},
    handleSavedViewChange = () => {},
    handleDeleteSavedView = () => {},
    onRefreshClick = () => {},
    onSaveIconClick = () => {},
    saveViewOptions = [],
    valueAfterFilterSelection = null,
    filterProdFamData = [],
    filterSiteData = [],
    filterStatusData = [],
    showSearchBox = true,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid style={modernFilterPanel}>
      {showSearchBox ?? (
        <Paper
          width={'300px'}
          sx={{
            marginBottom: '1rem',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          }}
        >
          <InputTextField
            name={'SearchBox'}
            placeholder={`${t('Search')}...`}
            style={{
              padding: '12px',
              marginBottom: '0',
            }}
            onChange={event => handleSearchChange(event)}
          />
        </Paper>
      )}
      <Paper
        component={'div'}
        sx={{
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          padding: '8px',
          position: 'relative',
          zIndex: 10,
        }}
      >
        <Grid sx={{ flex: 1 }}>
          <CustomSelect
            name={'mySavedViews'}
            id={'mySavedViews'}
            placeholder={t('My_Saved_Views')}
            options={saveViewOptions}
            styles={SavedViewStyle}
            onChange={handleSavedViewChange}
            onDeleteOption={handleDeleteSavedView}
            value={valueAfterFilterSelection || null}
          />
        </Grid>
        <Grid style={SaveIconStyle}>
          <IconButton onClick={onSaveIconClick}>
            <SaveIcon
              fontSize="large"
              style={pointerCursor}
              sx={{ color: '#1F305E' }}
            />
          </IconButton>
        </Grid>
      </Paper>
      {filterSiteData.length > 0 ? (
        <Filter
          productFamilyList={filterProdFamData}
          siteListData={filterSiteData}
          statusListData={filterStatusData}
          handleRefreshClick={onRefreshClick}
        />
      ) : (
        <Grid style={homeButtonComponent} width={300}>
          <CircularProgress />
        </Grid>
      )}
    </Grid>
  );
};

export default LeftPanel;
